import { render, staticRenderFns } from "./PurchaseInfo.vue?vue&type=template&id=4603c625&scoped=true"
import script from "./PurchaseInfo.vue?vue&type=script&lang=js"
export * from "./PurchaseInfo.vue?vue&type=script&lang=js"
import style0 from "./PurchaseInfo.vue?vue&type=style&index=0&id=4603c625&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4603c625",
  null
  
)

export default component.exports